module.exports = __webpack_public_path__ + "static/questions-9b16ead545f669c444afd42526c9f763.png";